import { apiClient } from './apiClient';

export class ActivityLogService {
    constructor() {
        this.BASE_URL = '/activities';
    }

    /**
     * Get all activities for a case with optional filters
     * @param {string} caseId - Case ID
     * @param {Object} options - Filter options
     * @param {string[]} options.categories - Filter by activity categories
     * @param {string[]} options.types - Filter by activity types
     * @param {number} options.limit - Limit number of results
     * @param {Date} options.fromDate - Start date filter
     * @param {Date} options.toDate - End date filter
     */
    async getActivitiesByCase(caseId, options = {}) {
        try {
            const params = new URLSearchParams();

            if (options.categories && options.categories.length > 0) {
                params.append('categories', options.categories.join(','));
            }

            if (options.types && options.types.length > 0) {
                params.append('types', options.types.join(','));
            }

            if (options.limit) {
                params.append('limit', options.limit.toString());
            }

            if (options.fromDate) {
                params.append('fromDate', options.fromDate.toISOString());
            }

            if (options.toDate) {
                params.append('toDate', options.toDate.toISOString());
            }

            const queryString = params.toString();
            const url = `${this.BASE_URL}/case/${caseId}${queryString ? `?${queryString}` : ''}`;

            const response = await apiClient.get(url);
            return response;
        } catch (error) {
            console.error('Error fetching activities by case:', error);
            throw error;
        }
    }



}

export const activityLogService = new ActivityLogService();
export default activityLogService;